import { render } from "./COIActionBarChangeVendor.vue?vue&type=template&id=ba55f03e"
import script from "./COIActionBarChangeVendor.vue?vue&type=script&lang=js"
export * from "./COIActionBarChangeVendor.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__